import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  option: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
};
const defaultProps = {
  className: '',
};

export const AddResourceMenuItem = ({ className, option }) => {
  const styles = useStyles();

  return (
    <div className={cx(styles.root, className)}>
      <CustomTypography
        className={styles.text}
        variant={TYPOGRAPHY_VARIANT.medium14}
      >
        {option?.name}
      </CustomTypography>
    </div>
  );
};
AddResourceMenuItem.displayName = 'AddResourceMenuItem';
AddResourceMenuItem.propTypes = propTypes;
AddResourceMenuItem.defaultProps = defaultProps;
